import { flattenObj } from '@clearverify/utils';

import type { DefaultDataRow } from 'src/components/table/types';
import { downloadFilesFromTable } from 'src/utils/file';

export const handleDownload = async <TRecord extends { id?: string | null } = DefaultDataRow>(
  selected: TRecord[],
  filePath?: string,
  companyPath?: string,
) => {
  const mappedRows = selected.map(element => {
    const flattenElement = flattenObj(element);
    return {
      filename: flattenElement[`${filePath}.filename`],
      downloadUrl: flattenElement[`${filePath}.downloadUrl`],
      companyName: flattenElement[`${companyPath}.name`],
    };
  });

  await downloadFilesFromTable(mappedRows);
};
